<template>
    <span>
        <modal v-if="showModal" @close="showModal=false" @confirm="cancel()">
            <div slot="header" style="font-family: MuseoSans-700; color: #138366;font-size:1.4em">
              Custom Form
            </div>
            <span slot="body">
                <schema-form v-model="formData" :schema="schema" @submit="save()">
                    <div slot="actions">
                        <button class="button is-primary" type="submit">Save</button>
                        <button class="button is-black" @click="showModal=false">Cancel</button>
                    </div>
                </schema-form>
            </span>
            <span slot="footer"/>
        </modal>
        <span @click="OpenForm()">
            <slot name="trigger"></slot>
        </span>
    </span>
</template>

<script>
import {mapActions} from 'vuex'
import Modal from '@/components/Modal'
export default {
  name: 'schemaFormModal',
  props: ['shipment', 'defaultForm'],
  data () {
    return {
      formData: {},
      showModal: false
    }
  },
  mounted () {
  },
  components: {Modal},
  computed: {
    schema () {
      if (!this.shipment || !this.shipment.schema_form || this.isEmpty(this.shipment.schema_form)) {
        return this.defaultForm || {}
      } else {
        return this.shipment.schema_form
      }
    }
  },
  methods: {
    ...mapActions({
      setAttachment: 'shipment/attachment'
    }),
    isEmpty (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false
        }
      }
      return true
    },
    OpenForm () {
      if (this.shipment && this.shipment.sf_data) {
        this.formData = JSON.parse(JSON.stringify(this.shipment.sf_data))
      } else {
        this.formData = {}
      }
      this.showModal = true
    },
    save () {
      if (this.formData && JSON.stringify(this.formData) !== JSON.stringify(this.shipment.sf_data)) {
        this.setAttachment({id: this.shipment.id, sf_data: this.formData, schema_form: this.schema}).then(response => {
          this.shipment.sf_data = this.formData
          this.shipment.schema_form = this.schema
        })
      }
      this.showModal = false
    }
  }
}
</script>


<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/SchemaFormModal.vue